// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__SKQBv","modalForm":"UpgradeEpcsModal_modalForm__1X6XS","modalFooter":"UpgradeEpcsModal_modalFooter__3O_FT"};